import React from 'react'
import { I18n } from 'react-redux-i18n'
import { Button } from 'reactstrap'
import '../styles.scss'
import LandingLocale from 'components/common/LandingLocale'

const PageChangePasswordSuccess = (props) => {
  return (
    <div className='nfrl page-change-password-success'>
      <div className='animated fadeIn'>
        <div className='logo-container'>
          <img src={'/img/logo-white.svg'} alt='Logo' />
        </div>

        <div className="page-container">
          <div className="form-container">
            <span className='form-title'>{I18n.t('nfrl_change_password_success_title')}</span>

            <div className="text-pass-success">
              <div>{I18n.t('nfrl_change_password_success')}</div>
            </div>

            <Button className='submit-button' onClick={() => props.history.push('/login')}>
              <div>{I18n.t('nfrl_change_password_btn_login')}</div>
            </Button>
          </div>
        </div>
      </div>
      <LandingLocale
        direction='top'
        darkMode
      />
    </div>
  )
}

export default PageChangePasswordSuccess